<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53 9H11a2 2 0 00-2 2v42a2 2 0 002 2h42a2 2 0 002-2V11a2 2 0 00-2-2zm-1 43H12V18h40zm0-36H12v-4h40z"/><path d="M18 48h28a2 2 0 002-2V28a2 2 0 00-2-2H18a2 2 0 00-2 2v18a2 2 0 002 2zm0-20h28v18H18zM21 20h22v2H21z"/><circle cx="17" cy="14" r="1"/><circle cx="24" cy="14" r="1"/><circle cx="40" cy="14" r="1"/><circle cx="47" cy="14" r="1"/><path d="M31 15h2a1 1 0 000-2h-2a1 1 0 000 2z"/></svg>